import _ from 'lodash';

/* @ngInject */
export default class {
  constructor($q) {
    this.$q = $q;
    this.loggedIn = false;
    this.admin = false;
    this.author = false;
    this.team_leader = false;
    this.sysAdmin = false;
    this.is_organizer = false;
    this.is_user = false;
    this.credits = null;
    this.email = null;
    this.profile_uid = false;
    this.event_coordinator = false;
  }

  admin() {
    return this.admin;
  }

  get isAdmin() {
    return this.admin;
  }

  get isAuthor() {
    return this.author;
  }

  get isTeamLeader() {
    return this.team_leader;
  }

  get isEventCoordinator() {
    return this.event_coordinator;
  }

  author() {
    return this.author;
  }

  sysAdmin() {
    return this.sysAdmin;
  }

  get isUser() {
    return this.is_user;
  }

  get credit() {
    return this.credits;
  }

  get profileUid() {
    return this.profile_uid;
  }

  email() {
    return this.email;
  }

  get userStatus() {
    return this.loggedIn;
  }

  set userStatus(status) {
    this.loggedIn = status;
  }

  resetClass() {
    this.admin = false;
    this.author = false;
    this.credits = null;
    this.email = null;
    this.is_organizer = false;
    this.is_user = false;
    this.loggedIn = false;
    this.profile_uid = false;
    this.sysAdmin = false;
    this.sysAdmin = false;
    this.team_leader = false;
    this.event_coordinator = false;
    return this.$q.resolve(true);
  }

  setRoles(userData) {
    return this.$q(resolve => {
      this.loggedIn = true;
      this.email = userData.email;
      this.admin = _.isEmpty(userData) ? false : userData.admin;
      this.team_leader = _.isEmpty(userData) ? false : userData.team_leader;
      this.event_coordinator = _.isEmpty(userData) ? false : userData.event_coordinator;
      this.sysAdmin = _.isEmpty(userData) ? false : userData.sysAdmin;
      this.author = _.isEmpty(userData) ? false : userData.author;
      this.profile_uid = _.isEmpty(userData) ? false : userData.profile_uid;
      this.organizer = _.isEmpty(userData) ? null : userData.organizer_id;
      resolve(this.loggedIn);
    });
  }

  unsetRoles() {
    this.loggedIn = false;
    this.admin = false;
    this.team_leader = false;
    this.author = false;
    this.sysAdmin = false;
    this.email = null;
    this.is_user = false;
    this.event_coordinator = false;
    return this.$q.resolve('LOGGED OUT');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/UserClass.js